import { TalismanMark } from './Icons';

export const ModernCompass = ({ size = 64 }: { size?: number }) => (
  <div className="relative flex items-center justify-center" style={{ width: size * 1.4, height: size * 1.4 }}>
    {/* Soft Glow */}
    <div className="absolute inset-0 bg-gold/5 blur-2xl rounded-full" />

    {/* Rotate the mark with CSS, independent of React renders and Motion. */}
    <div
        className="relative z-10 flex items-center justify-center bg-white rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gold/10"
        style={{ width: size, height: size }}
    >
      <TalismanMark size={size * 0.65} className="brandmark-rotate" />
    </div>
  </div>
);
